import { render } from "./EditAgendaListItems.vue?vue&type=template&id=2e8db8d9&scoped=true"
import script from "./EditAgendaListItems.vue?vue&type=script&lang=js"
export * from "./EditAgendaListItems.vue?vue&type=script&lang=js"

import "./EditAgendaListItems.vue?vue&type=style&index=0&id=2e8db8d9&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e8db8d9"]])

export default __exports__